import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Sample department image (replace with actual images as needed)
const defaultDeptImage =
  "https://cdn-icons-png.flaticon.com/512/901/901162.png";

const departmentList = [
  {
    name: "Gastroenterologist",
    display:"Gastroenterology",
    className: "div-Gastro",
    image: '/images/Departments/Gastroenterologist 1.jpg',
    description:
      "Dedicated to digestive system health and treatment of conditions like ulcers, IBS, and liver diseases.",
  },
  {
    name: "Endocrinologist",
    display:"Endocrinology",
    className: "div-GeneralMedicine",
    image: '/images/Departments/Endocrinologist 1.jpg',
    description:
      "Comprehensive healthcare including check-ups, preventive care, and diagnosis of common illnesses.",
  },
  {
    name: "Cardiologist",
    display:"Cardiology",
    className: "div-Cardiology",
    image: '/images/Departments/Cardiologist.jpg',
    description:
      "Focused on diagnosing and treating heart-related issues using the latest cardiac care methods.",
  },
  {
    name: "Dermatologist",
    display:"Dermatology",
    className: "div-Dermatology",
    image: '/images/Departments/Dermatologist.jpg',
    description:
      "Treats various skin issues through both medical and cosmetic dermatology techniques.",
  },
  {
    name: "Pulmonologist",
    display:"Pulmonology",
    className: "div-InternalMedicine",
    image: '/images/Departments/Pulmonologist1.jpg',
    description:
      "Deals with prevention, diagnosis, and treatment of internal diseases for adults.",
  },
  {
    name: "Nephrologist",
    display:"Nephrology",
    className: "div-Orthopedics",
    image: '/images/Departments/Nephrologist1.jpg',
    description:
      "Specialized in musculoskeletal issues involving bones, joints, ligaments, and muscles.",
  },
  {
    name: "Neurologist",
    display:"Neurology",
    className: "div-Neurology",
    image: '/images/Departments/Neurologist.jpg',
    description:
      "Handles disorders affecting the nervous system including the brain and spinal cord.",
  },
  {
    name: "Oncologist",
    display:"Oncology",
    className: "div-Oncology",
    image: '/images/Departments/Oncologist.jpg',
    description:
      "Expert care and treatment for cancer patients, including diagnosis and therapies.",
  },
 {
  name: "Rheumatologist",
  display:"Rheumatology",
  className: "div-Rheumatology",
  image: '/images/Departments/Rheumatologist 1.jpg',
  description:
    "Focused on the diagnosis and treatment of autoimmune and inflammatory diseases affecting joints, muscles, and bones, such as arthritis, lupus, and rheumatoid conditions.",
},
{
  name: "Hematologist",
  display:"Hematology",
  className: "div-Hematology",
  image:'/images/Departments/Hematologist 1.jpg',
  description:
    "Diagnosis and treatment of blood disorders, including anemia, leukemia, and clotting abnormalities.",
},
{
  name: "Dentist",
  display:"Dentist",
  className: "div-AllergyImmunology",
  image: '/images/Departments/Dentist 1.jpg',
  description:
    "A dentist specializes in diagnosing, treating, and preventing diseases of the teeth, gums, and mouth.",
},
{
  name: "Gynecologist",
  display:"Gynecology",
  className: "div-Gynecology",
  image: '/images/Departments/Gynecologist.jpg',
  description:
    "Provides specialized care for women’s reproductive health, including diagnosis, treatment, and preventive services.",
},
{
  name: "Psychiatrist",
  display:"Psychiatry",
  className: "div-Psychiatry",
  image: '/images/Departments/Psychiatrist.jpg',
  description:
    "Focuses on the diagnosis, treatment, and prevention of mental, emotional, and behavioral disorders.",
},
{
  name: "Orthopedic Surgeon",
  display: "Orthopaedics",
  className: "div-Orthopaedic",
  image:  '/images/Departments/Gastroenterologist 1.jpg',
  description:
    "Specializes in diagnosing and treating conditions related to the bones, joints, ligaments, tendons, and muscles.",
},
{
  name: "Ophthalmologist",
  display: "Ophthalmology",
  className: "div-Ophthalmology",
  image:  "/images/Departments/Ophthalmologist3.jpg",
  description:
    "Deals with the diagnosis and treatment of eye disorders, including vision care, surgeries, and eye diseases.",
},
{
  name: "General Surgeon",
  display: "General Surgeon",
  className: "div-GeneralSurgeon",
  image: "/images/Departments/General Surgeon.jpg",
  description:
    "Specializes in surgical procedures involving the abdomen, digestive tract, and other vital organs, focusing on diagnosis, preoperative, and postoperative care.",
},
{
  name: "General Physician",
  display: "General Physician",
  className: "div-GeneralPhysician",
  image: "/images/Departments/General Physician.jpeg",
  description:
    "Provides comprehensive primary care for adults, focusing on the prevention, diagnosis, and treatment of a wide range of conditions.",
},
{
  name: "Pediatrician",
  display: "Paediatrics",
  className: "div-Paediatrics",
  image: "/images/Departments/Pediatrician.jpg",
  description:
    "Specializes in the medical care of infants, children, and adolescents, focusing on growth, development, and disease prevention.",
},
// {
//   name: "EmergencyMedicine",
//   display: "Emergency Medicine",
//   className: "div-EmergencyMedicine",
//   image:    "/images/Departments/EmergencyMedicine 1.jpg",
//   description:
//     "Provides immediate medical attention for acute illnesses and injuries, focusing on rapid diagnosis and treatment in critical situations.",
// },
{
  name: "ENT Specialist",
  display: "ENT",
  className: "div-ENT",
  image:  "/images/Departments/ENT Specialist 1.jpg",
  description:
    "Focuses on the diagnosis and treatment of conditions related to the ear, nose, throat, head, and neck.",
},
{
  name: "Radiologist",
  display: "Radiology",
  className: "div-Radiologist",
  image:        "/images/Departments/Radiologist1.jpg",
  description:
    "Specializes in using imaging techniques like X-rays, CT scans, and MRIs to diagnose and monitor diseases and injuries within the body.",
},
{
  name: "Anesthesiologist",
  display: "Anesthesiology",
  className: "div-Anesthesiologist",
  image:          "/images/Departments/Anesthesiologist1.jpg",
  description:
    "Expert in administering anesthesia and managing pain during surgeries and other medical procedures, ensuring patient safety and comfort.",
},
{
  name: "Urologist",
  display: "Urology",
  className: "div-Urologist",
  image:      "/images/Departments/Urologist 1.jpg",
  description:
    "Focuses on the urinary tract and male reproductive organs, diagnosing and treating conditions like kidney stones, infections, and prostate issues.",
},
{
  name: "Plastic Surgeon",
  display: "Plastic Surgery",
  className: "div-PlasticSurgeon",
  image:      '/images/Departments/plastic surgeon1.jpg',
  description:
    "Performs reconstructive and cosmetic surgeries to restore or enhance appearance and function following injury, disease, or congenital defects.",
},
{
  name: "Cosmetologist",
  display: "Cosmetology",
  className: "div-Cosmetologist",
  image: "/images/Departments/Cosmetologist 1.jpg",
  description:
    "Specializes in aesthetic treatments for skin, hair, and nails, offering services to enhance beauty and maintain healthy appearance.",
},
{
  name: "Pathologist",
  display: "Pathology",
  className: "div-Pathologist",
  image: "/images/Departments/pathologist.jpg",
  description:
    "Examines tissues, organs, and bodily fluids to diagnose diseases, playing a key role in guiding treatment decisions and medical research.",
},
{
  name: "Sexologist",
  display: "Sexology",
  className: "div-Sexologist",
  image:  "/images/Departments/Sexologist.jpg",
  description:
    "Focuses on sexual health, addressing issues related to intimacy, sexual dysfunction, and overall reproductive wellbeing in men and women.",
},
{
  name: "Allergist/Immunologist",
  display: "Allergist/Immunology",
  className: "div-AllergistImmunologist",
  image:           '/images/Departments/Allergist Immunologist 1.jpg',
  description:
    "Diagnoses and treats allergies, asthma, and immune system disorders, helping patients manage chronic allergic reactions and immune deficiencies.",
},
{
  name: "Diabetologist",
  display: "Diabetology",
  className: "div-Diabetologist",
  image: "/images/Departments/Diabetologist 1.jpg",
  description:
    "Specializes in the diagnosis and management of diabetes and related metabolic disorders, helping patients maintain optimal blood sugar control.",
},
{
  name: "Laparoscopic Surgeon",
  display: "Laparoscopic Anatomy",
  className: "div-LaparoscopicSurgeon",
  image: "/images/Departments/Laparoscopic Surgeon.jpg",
  description:
    "Performs minimally invasive surgeries using small incisions and advanced instruments, reducing pain, scarring, and recovery time for patients.",
},
{
  name: "Internal Medicine Specialist",
  display: "Internal Medicine ",
  className: "div-InternalMedicineSpecialist",
  image: "/images/Departments/Internal Medicine Specialist 2.jpg",
  description:
    "Provides comprehensive care for adults, focusing on the prevention, diagnosis, and treatment of complex or chronic diseases affecting internal organs.",
},
{
  name: "Homeopathic Doctor",
  display: "Homeopathy",
  className: "div-HomeopathicDoctor",
  image:  "/images/Departments/Homeopathic doctor1.jpg",
  description:
    "Uses natural remedies based on homeopathic principles to stimulate the body’s healing response and promote overall wellness.",
},
{
  name: "Ayurvedic Doctor",
  display: "Ayurvedic ",
  className: "div-AyurvedicDoctor",
  image: "/images/Departments/Ayurvedic Doctor 1.jpg",
  description:
    "Practices Ayurveda, offering herbal and lifestyle-based treatments that restore balance between body, mind, and spirit for holistic healing.",
},
{
  name: "Unani Practitioner",
  display: "Unani Medicine",
  className: "div-UnaniPractitioner",
  image: "/images/Departments/Unani Practitioner1.jpg",
  description:
    "Applies traditional Unani medicine principles using natural substances and therapies to promote health and treat chronic ailments.",
},
{
  name: "Occupational Therapist",
  display: "Occupational Therapy",
  className: "div-OccupationalTherapist",
  image: "/images/Departments/Occupational Therapist1.jpg",
  description:
    "Helps individuals regain independence and improve their ability to perform daily activities after illness, injury, or disability.",
},
{
  name: "Physiotherapist",
  display: "Physiotherapy",
  className: "div-Physiotherapist",
  image: "/images/Departments/Physiotherapist2.jpg",
  description:
    "Provides physical rehabilitation through exercises, manual therapy, and movement techniques to restore mobility and relieve pain.",
},


];

function Departments({isLoading}) {
  const navigate = useNavigate();
  const location = useLocation();
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-full max-w-7xl p-6 space-y-6 animate-pulse">
          <div className="h-10 w-1/3 bg-gray-300 rounded-lg"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(9)].map((_, i) => (
              <div
                key={i}
                className="h-64 bg-gray-200 rounded-lg shadow-sm"
              ></div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  return (
    <main>
      <div style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4 d-flex justify-content-between"
          >
            <div>
              <h2 className="h3 fw-bold" style={{fontSize:'24px'}}>Clinic Departments</h2>
              {/* <p className="text-secondary">
                Create and manage medical departments within your clinic.
              </p> */}
            </div>
          </div>
        </div>

        <div
          className="row bg-white p-2 rounded-2"
          style={{ overflowY: "scroll", height: "100%" }}
        >
          <div className="row mb-4">
            {departmentList.map((dept, idx) => (
              <div key={idx} className="col-12 col-lg-4 col-md-6 mb-4">
                <div className="cardbody p-2 border rounded-3 div-boxbodyshadow">
                  {/* Department Image */}
                  <img
                    src={dept.image}
                    alt={dept.name}
                    className="w-100 rounded-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />

                  <div className="p-2">
                    <h5 className="fw-bold mb-1">{dept.display}</h5>
                    <p
                      style={{
                        fontSize: "0.85rem",
                        marginTop: "0.5rem",
                        color: "#5f5f5f",
                        minHeight: "75px",
                      }}
                    >
                      {dept.description}
                    </p>
                  </div>
                  <hr />
                  <div className="row d-flex align-items-center p-1">
                    <div className="col-8">
                      <div className="d-flex align-items-center">
                        <div className="div-Rounded"></div>
                        <div className="div-Rounded"></div>
                        <div className="div-Rounded"></div>
                        <div className="div-Rounded"></div>
                        <span
                          className="ms-2"
                          style={{ fontSize: "0.75rem", color: "#6b6b6b" }}
                        >
                          +7 Others
                        </span>
                      </div>
                    </div>
                    <div className="col-4 text-end">
                      <button
                        className="gradient-button"
                        onClick={() => navigate(`/DepartmentDetails/${dept.name}/${dept.display}?from=${encodeURIComponent(
              location.pathname + location.search
            )}`)}
                      >
                        See Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}

export default Departments;
